export const SET_INVENTORY = 'Set inventory'
export const DELETE_INVENTORY = 'Delete inventory'
export const UPDATE_INVENTORY = 'Update inventory'
